import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Form,
  Button,
  Alert as AlertControl,
} from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ServiceAdmin from "../Services/ServiceAdmin";

const EditeCabiner = (props) => {
  // data from profile
  const { show2, Toggle2, cabinet } = props;
  //Modal
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const HandelClick = () => {
    setMessage("fadili");
    setSeverity("warning");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    Toggle2();
  };
  // Form Cabiner
  const currentUser = JSON.parse(sessionStorage.getItem("user"));
  const user = {
    id: currentUser && currentUser.id,
  };
  const [denomination, setDenomination] = useState("");
  const [address, setAddress] = useState("");
  const [tel, setTel] = useState("");
  const [patent, setPatent] = useState("");
  const [numRC, setNumRC] = useState("");
  const [rib, setRib] = useState("");
  const [ice, setIce] = useState("");
  const [banque, setBanque] = useState(" ");
  const [formeJuridique, setFormeJuridique] = useState("");

  // add Cabinet

  const HandleAddCabinet = (e) => {
    ServiceAdmin.addcabinet(
      denomination,
      address,
      tel,
      patent,
      numRC,
      rib,
      ice,
      banque,
      formeJuridique,
      user
    ).then((res) => {
      window.location.reload();
      window.location.replace("/profile");
    });
  };
  //
  //console.log("state ---->", denomination);

  // get Cabinet
  const item = cabinet && cabinet.laboratory;
  //console.log("item --->", item.id);
  useEffect(() => {
    GetDataCabinet();
  }, [item]);

  const GetDataCabinet = () => {
    if (item) {
      setDenomination(item.denomination);
      setAddress(item.address);
      setTel(item.tel);
      setPatent(item.patent);
      setNumRC(item.numRC);
      setRib(item.rib);
      setIce(item.ice);
      setBanque(item.banque);
      setFormeJuridique(item.formeJuridique);
    }
  };

  // update cabinet
  const HandleUpdateCabinet = () => {
    ServiceAdmin.updatecabinet(
      item.id,
      denomination,
      address,
      tel,
      patent,
      numRC,
      rib,
      ice,
      banque,
      formeJuridique,
      user
    ).then((res) => {
      window.location.reload();
      window.location.replace("/profile");
    });
  };

  const [contorl, setControl] = useState(false);

  return (
    <div>
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>

      <Modal show={show2} onHide={Toggle2} size="xl">
        <Modal.Body>
          <img
            src="https://img.icons8.com/fluent/48/000000/close-window.png"
            style={{ float: "right" }}
            onClick={() => {
              Toggle2();
            }}
          />
          <h6
            style={{
              marginTop: "27px",
              marginBottom: "18px",
              fontSize: "x-large",
            }}
          >
            Cabinet
          </h6>
          <Container>
            <Row>
              <Col lg={4}>
                <div className="profile-header mb-2">
                  <h3>
                    <span>Dénomination :</span>
                  </h3>
                  <Form.Control
                    required
                    defaultValue={denomination}
                    onChange={(e) => {
                      setDenomination(e.target.value);
                      setControl(false);
                    }}
                  />
                </div>
                {contorl && (
                  <AlertControl variant="warning">
                    Le champ est obligatoire
                  </AlertControl>
                )}
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Patente :</span>
                  </h3>
                  <Form.Control
                    defaultValue={patent}
                    onChange={(e) => setPatent(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>RC :</span>
                  </h3>
                  <Form.Control
                    defaultValue={numRC}
                    onChange={(e) => setNumRC(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Forme Juridique :</span>
                  </h3>
                  <Form.Control
                    as="select"
                    custom
                    defaultValue={formeJuridique}
                    onChange={(e) => setFormeJuridique(e.target.value)}
                  >
                    <option>SARL</option>
                    <option>AUTRE</option>
                  </Form.Control>
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Rib :</span>
                  </h3>
                  <Form.Control
                    defaultValue={rib}
                    onChange={(e) => setRib(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Banque :</span>
                  </h3>
                  <Form.Control
                    as="select"
                    custom
                    defaultValue={banque}
                    onChange={(e) => setBanque(e.target.value)}
                  >
                    <option>BMCI</option>
                    <option>BMCE</option>
                    <option>GFI</option>
                  </Form.Control>
                </div>
              </Col>

              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Ice :</span>
                  </h3>
                  <Form.Control
                    defaultValue={ice}
                    onChange={(e) => setIce(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Adresse :</span>
                  </h3>
                  <Form.Control
                    defaultValue={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
              </Col>
              <Col lg={4}>
                <div className="profile-header">
                  <h3>
                    <span>Téléphone :</span>
                  </h3>
                  <Form.Control
                    defaultValue={tel}
                    onChange={(e) => setTel(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          {item && item.denomination ? (
            <Button
              className="btn"
              variant="success"
              onClick={() =>
                denomination ? HandleAddCabinet() : setControl(true)
              }
              style={{
                float: "right",
                width: "160px",
              }}
            >
              Modifier
            </Button>
          ) : (
            <Button
              className="btn"
              variant="primary"
              onClick={() =>
                denomination ? HandleAddCabinet() : setControl(true)
              }
              style={{
                float: "right",
                width: "160px",
              }}
            >
              Ajouter
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditeCabiner;
